module.exports = __webpack_public_path__ + "static/EOS CANADA-1e2ae98a2dc1db22b3e2a5a49b8acd55.png";